import React from 'react';
import { Alert, Button } from '@mui/material';
import api from '../../utils/api';
import { clearGhostLoginReturn, getGhostLoginReturn } from '../../utils/ghostLoginSession';

function GhostLoginBanner() {
  const returnSession = getGhostLoginReturn();
  if (!returnSession) {
    return null;
  }

  const handleExit = () => {
    try {
      const { token, userType } = JSON.parse(returnSession);
      localStorage.setItem('token', token);
      localStorage.setItem('userType', userType || 'admin');
      clearGhostLoginReturn();
      localStorage.removeItem('weddingId');
      localStorage.removeItem('currentBusinessId');
      api.defaults.headers.common['x-auth-token'] = token;
      window.location.href = '/admin/users';
    } catch {
      clearGhostLoginReturn();
      window.location.href = '/admin/login';
    }
  };

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button color="inherit" size="small" onClick={handleExit}>
          Return to admin
        </Button>
      }
    >
      You are viewing this account as an admin (ghost login). Actions you take will appear as this user.
    </Alert>
  );
}

export default GhostLoginBanner;
